import React from 'react';
import { Field, reduxForm } from 'redux-form';
import { renderField, renderSwitch } from '../../../Utils/renderField/renderField';
import IconCheck from '../../../../icons/check';

const Form = (props) => {
    const {
        handleSubmit,
        onCancel,
        id,
        showBtns=true
    } = props;

    return (
        <form onSubmit={handleSubmit} id={id} className="d-flex flex-wrap">
            <div className="col-12">
                <div className="form-group">
                    <label htmlFor="name" className="fw-600">
                        Company Name<span className="text-primary ml-1">*</span>
                    </label>
                    <Field
                        name="name"
                        component={renderField}
                    />
                </div>
            </div>
            <div className="col-12">
                <div className="form-group">
                    <label htmlFor="contact_email" className="fw-600">
                        Contact Email<span className="text-primary ml-1">*</span>
                    </label>
                    <Field
                        name="contact_email"
                        component={renderField}
                    />
                </div>
            </div>
            <div className="col-12">
                <div className="form-group d-flex justify-content-between">
                    <label htmlFor="active" className="fw-600">
                        Active Status
                    </label>
                    <Field
                        name="active"
                        component={renderSwitch}
                    />
                </div>
            </div>
            {showBtns && (
                <div className="col-12 d-flex justify-content-end">
                    <button type="button"
                        className="btn btn-outline-secondary m-1"
                        onClick={onCancel}
                    >
                        <span className="fw-600">
                            Cancel
                        </span>
                    </button>
                    <button type="submit" className="btn btn-primary m-1">
                        <IconCheck className="smallIcon" />
                        <span className="fw-600">
                            Save Changes
                        </span>
                    </button>
                </div>
            )}
        </form>
    )
}

export default reduxForm({
    form: "vendor",
    validate: (data) => {
        const errors = {}
        if (!data.name) errors.name = "Required Field";
        if (!data.contact_email) errors.contact_email = "Required Field";
        return errors;
    }
})(Form);
